
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";
import { Menu, X } from "lucide-react";

export const LandingNav = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? "bg-white/80 backdrop-blur-md shadow-sm border-b border-gray-100 py-3" : "bg-transparent py-5"
                }`}
        >
            <div className="container mx-auto px-4 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2">
                    <img src={logo} alt="RaffleKit" className="w-10 h-10" />
                    <span className="font-heading font-bold text-xl text-gray-900">RaffleKit</span>
                </Link>

                {/* Desktop Nav */}
                <div className="hidden md:flex items-center gap-8">
                    <Link to="/features" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">Features</Link>
                    <Link to="/how-it-works" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">How It Works</Link>
                    <Link to="/pricing" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">Pricing</Link>
                    <Link to="/admin" className="text-sm font-medium text-gray-600 hover:text-primary transition-colors">Login</Link>
                    <Button asChild size="sm" variant="accent" className="rounded-full px-6">
                        <Link to="/admin?mode=signup">Start Free</Link>
                    </Button>
                </div>

                {/* Mobile Toggle */}
                <button
                    className="md:hidden p-2 text-gray-600"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <X /> : <Menu />}
                </button>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-gray-100 p-4 flex flex-col gap-4 shadow-lg animate-fade-in">
                    <Link to="/features" className="text-sm font-medium text-gray-600 py-2" onClick={() => setIsMobileMenuOpen(false)}>Features</Link>
                    <Link to="/how-it-works" className="text-sm font-medium text-gray-600 py-2" onClick={() => setIsMobileMenuOpen(false)}>How It Works</Link>
                    <Link to="/pricing" className="text-sm font-medium text-gray-600 py-2" onClick={() => setIsMobileMenuOpen(false)}>Pricing</Link>
                    <Link to="/admin" className="text-sm font-medium text-gray-600 py-2" onClick={() => setIsMobileMenuOpen(false)}>Login</Link>
                    <Button asChild variant="accent" className="w-full rounded-full">
                        <Link to="/admin?mode=signup" onClick={() => setIsMobileMenuOpen(false)}>Start Free</Link>
                    </Button>
                </div>
            )}
        </nav>
    );
};
